<template>
  <v-pagination
    v-model="page"
    :length="pageCount"
  />
</template>

<script setup lang="ts">
import {storeMap} from '@/plugins/piniaStoreById';
import {computed} from 'vue';
const props = defineProps({
  module: {
    type: String,
    required: true,
  },
});

const store = storeMap.get(props.module);

const page = computed({
  get(): number {
    if (!store) return 0;
    return store.page + 1;
  },
  async set(newPage: number) {
    if (!store) return;
    store.page = newPage - 1;
  },
});
const pageCount = computed((): number => {
  if (!store) return 0;
  return store.pageCount;
});

defineExpose({
  page,
  pageCount,
});
</script>
